import script from "./AppOverview.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppOverview.vue?vue&type=script&lang=ts&setup=true"

import "./AppOverview.vue?vue&type=style&index=0&id=89d78d02&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89d78d02"]])

export default __exports__